import script from "./combinedReference.vue?vue&type=script&setup=true&lang=js"
export * from "./combinedReference.vue?vue&type=script&setup=true&lang=js"

import "./combinedReference.vue?vue&type=style&index=0&id=86cd5ff6&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86cd5ff6"]])

export default __exports__